export const environment = {
  driverActionHostAgent: 'https://local.testsigmaagent.com:8484',
};
